export default {
  stylePrefix: 'trt-',

  // Specify the element to use as a container, string (query) or HTMLElement
  // With the empty value, nothing will be rendered
  appendTo: '',

  // Default options for the target input
  optionsTarget: [{ value: false }, { value: '_blank' }]
};



// WEBPACK FOOTER //
// webpack://grapesjs/src/trait_manager/config/config.js